<template>
	<div class="row">
		<div class="col-12">
			<Heading>Kunden</Heading>
			<div>
				<router-link class="btn btn-primary btn-sm px-5 mb-5" to="/admin/customers/add/new">
					<i class="fas fa-plus pr-4"></i>Kunden anlegen
				</router-link>
			</div>
			<SearchBar v-model="searchQuery" placeholder="Suche nach Kundennummer / Name / Standort"></SearchBar>
			<span class="text-primary d-inline-block mb-3">{{queryFilteredCustomer.length}} Treffer</span>

			<list :items="queryFilteredCustomer" :sort-asc="sort.asc" :sort-key="sort.key">
				<template v-slot:header>
					<div class="row">
						<div class="col-3" @click="setSortProps('customer_number')">
							Kundennummer
							<i v-if="sort.key === 'customer_number' && sort.asc" class="fas fa-chevron-up"></i>
							<i v-else-if="sort.key === 'customer_number' && !sort.asc" class="fas fa-chevron-down"></i>

						</div>
						<div class="col-3" @click="setSortProps('name')">
							Name
							<i v-if="sort.key === 'name' && sort.asc" class="fas fa-chevron-up"></i>
							<i v-else-if="sort.key === 'name' && !sort.asc" class="fas fa-chevron-down"></i>
						</div>
						<div class="col-5" @click="setSortProps('address')">
							Standort
							<i v-if="sort.key === 'address' && sort.asc" class="fas fa-chevron-up"></i>
							<i v-else-if="sort.key === 'address' && !sort.asc" class="fas fa-chevron-down"></i>

						</div>
						<div class="col-1"></div>
					</div>
				</template>
				<template v-slot:itemTemplate="{item}">
					<div class="row align-items-center py-1">
						<!--						 <div class="col-12">{{item}}</div>-->
						<div class="col-3">{{item.customer_number}}</div>
						<div class="col-3">{{item.name}}</div>
						<div class="col-5">
							{{item.address}},<br> {{item.postal}} {{item.city}}
						</div>
						<div class="col-1 text-right">
							<button class="btn" @click="$router.push('/admin/customers/'+item.id)">
								<i class="fas fa-chevron-right"></i>
							</button>
						</div>
					</div>
				</template>
			</list>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {mapActions, mapState} from "vuex";

	import Navigation from "../../components/admin/Navigation";
	import List from "../../components/admin/List";
	import SearchBar from "../../components/admin/SearchBar";
	import Heading from "../../components/admin/Heading";
	import BottleState from "../../components/admin/BottleState";

	export default {
		name: "CustomerList",
		components: {BottleState, List, Navigation, Heading, SearchBar},
		data() {
			return {
				searchQuery: "",
				sort: {
					key: 'customer_number',
					asc: true
				}
			}
		},
		computed: {
			...mapState({
        customers: state => state.Api.Customers.all
      }),
			queryRegex() {
				return new RegExp(this.searchQuery.replace(' ', '.*'), 'i');
			},
			queryFilteredCustomer() {
				return this.customers.filter(el => {
					let matchName = (el.name || "").toLocaleLowerCase().match(this.queryRegex);
					let matchCustomerNo = (el.customer_number || "").toLocaleLowerCase().match(this.queryRegex);
					let matchStreet = (el.address || "").toLocaleLowerCase().match(this.queryRegex);
					let matchPostal = (el.postal || "").toLocaleLowerCase().match(this.queryRegex);
					let matchCity = (el.city || "").toLocaleLowerCase().match(this.queryRegex);

					return (matchName && matchName.length > 0)
						|| (matchCustomerNo && matchCustomerNo.length > 0)
						|| (matchStreet && matchStreet.length > 0)
						|| (matchPostal && matchPostal.length > 0)
						|| (matchCity && matchCity.length > 0);
				})
			},
		},
		mounted() {
			this.refreshCustomers()
		},
		methods: {
			...mapActions({
        refreshCustomers: "Api/Customers/all"
      }),
			setSortProps(key) {
				Vue.set(this.sort, 'key', key);
				Vue.set(this.sort, 'asc', !this.sort.asc);
			}
		},
	}
</script>

<style scoped>

</style>
